import React from "react"
import PropTypes from "prop-types"

import DateRangeForm from "apps/core/DateRange/DateRangeForm"
import { reverse } from "utils/urls"

export default function DateRangeUpdate(props) {
  return (
    <DateRangeForm
      {...props}
      isUpdate
      actionEndpoint={`/date-ranges/${props.match.params.id}/`}
      successUrl={reverse("dateRangeDetail", { id: props.match.params.id })}
    />
  )
}

DateRangeUpdate.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
